module.exports = __webpack_public_path__ + "img/cartao.3b37e932.svg";